import React from 'react';
import PanelPage from 'pages/panel-page';
import homeConfig from 'content-config/home';

const Home = () => {
  return (
    <PanelPage config={homeConfig} />
  );
};
export default Home;